import { QualificationBannerPattern } from 'images';
import * as T from 'prop-types';
import styled from 'styled-components/macro';

import { Box } from '@olist/united';

import QualificationBanner from './banners/qualification-banner';

const BoxArea = styled(Box)`
  @media (min-width: 1081px) {
    padding-right: 376px;
  }
`;

const BannerWrapper = ({ children }) => {
  // Add a Image or set as null
  const banner = QualificationBannerPattern;

  if (!banner) return children;

  return (
    <BoxArea>
      {children}
      <QualificationBanner banner={banner} />
    </BoxArea>
  );
};

BannerWrapper.propTypes = {
  children: T.node.isRequired,
};

export default BannerWrapper;
